import React, { Component } from "react";
import SortableTree from "react-sortable-tree";
import FileExplorerTheme from "react-sortable-tree-theme-minimal";
import _ from "lodash";
import { fetchChatbotBubbles, updateChatbotBubbles } from "../../../../redux/actions/chatbotBubblesActions";
import { pushMessage } from "../../../../redux/actions/commonActions";
// Material helpers
import { withStyles, Box, Button, CircularProgress, Typography } from "@material-ui/core";

// Redux
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

// Component styles
import styles from "./styles";

// React router
import { Link, withRouter } from "react-router-dom";

class Tree extends Component {
  constructor(props) {
    super(props);

    this.state = {
      treeData: [],
      loading: true
    };
  }

  canNodeHaveChildren = node => {
    if (node.type === "hierarchy") {
      return true;
    } else {
      return false;
    }
  };
  componentDidMount() {
    this.mounted = true;
    this.fetchData();
  }
 
  componentDidUpdate(prevProps) {
    if (prevProps.bubbles !== this.props.bubbles && this.props.bubbles && this.props.bubbles.status !== "success") {
      this.props.pushMessage({
        message: "Error occurred while trying to fetch bubbles!",
        type: "error"
      });
    }
    if (
      prevProps.updateResponse !== this.props.updateResponse &&
      this.props.updateResponse &&
      this.props.updateResponse.status !== "success"
    ) {
      this.props.pushMessage({
        message: "Error occurred while trying to update bubbles!",
        type: "error"
      });
    }
    if (
      prevProps.updateResponse !== this.props.updateResponse &&
      this.props.updateResponse &&
      this.props.updateResponse.status === "success"
    ) {
      this.props.pushMessage({
        message: "Updated bubbles!",
        type: "success"
      });
    }
  }

  fetchData = () => {
    this.props.fetchChatbotBubbles().then(() => {
      if (this.mounted) {
        let json = JSON.parse(
          JSON.stringify(_.get(this.props, "bubbles.bubbles", []))
            .split('"name":')
            .join('"title":')
        );
        this.setState({ treeData: json, loading: false });
      }
    });
  };

  updateBubbles = () => {
    let json = JSON.parse(
      JSON.stringify(this.state.treeData)
        .split('"title":')
        .join('"name":')
    );
    this.props.updateChatbotBubbles(json);
  };

  render() {
    const { loading, treeData } = this.state;
    const { classes } = this.props;
    if (!loading) {
      return (
        <>
        <Box className={classes.contentTitle}>
          <Typography variant="h4" component="h4">
            Configure AI Assistant Bubbles
          </Typography>
        </Box>
        <div className={classes.tabInnerContent}>
          {_.isEmpty(treeData) ? (
            <Typography>No bubbles defined!</Typography>
          ) : (
            <div>
              <SortableTree
                treeData={treeData}
                isVirtualized={false}
                onChange={treeData => this.setState({ treeData })}
                theme={FileExplorerTheme}
                canNodeHaveChildren={node => this.canNodeHaveChildren(node)}
              />
            </div>
          )}
          <div className={classes.tabContentActions}>
             <Button disabled={!treeData.length>0&&true} size="large" variant="contained" color="primary" onClick={() => this.updateBubbles()}>Save changes</Button>
          </div>
        </div>
        </>
      );
    } else {
      return <Box className={classes.contentTitle}><CircularProgress /></Box>;
    }
  }
}

function mapStateToProps(state) {
  return {
    bubbles: state.chatbotSettings.bubbles,
    updateResponse: state.chatbotSettings.updateResponse
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators(
      {
        fetchChatbotBubbles,
        updateChatbotBubbles,
        pushMessage
      },
      dispatch
    ),
    dispatch
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withStyles(styles)(Tree))
);
